<template>
  <div class="hello">
    <h1>Dekobäume und Echtblattpalmen werden nach Maß gefertigt !</h1>
    <div class="contact">
      <p>Geilehner KG</p>
      <p>
        E-Mail:
        <a href="mailto:geilehner.kg@aon.at">geilehner.kg@aon.at</a>
      </p>
      <p>
        Tel/Fax:
        <a href="tel:+4372587344">07258-7344</a> oder Mobil:
        <a href="tel:+436644086061">0664-4086061</a>
      </p>
    </div>
    <div class="grid">
      <div class="column">
        <img src="../assets/baum.jpg" />
        <p>Baum</p>
      </div>
      <div class="column">
        <img src="../assets/palme.jpg" />
        <p>Palme</p>
      </div>
    </div>
    <img class="skult" src="../assets/logo-skult.png" @click="openLink()" />
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  methods: {
    openLink() {
      window.open("http://www.bar-kult.at/");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1 {
  font-size: 1.5rem;
  padding: 2%;
}
p {
  padding: 0;
  line-height: 1rem;
  margin: 10px;
  a {
    text-decoration: none;
    color: grey;
  }
}
.column {
  display: inline-block;
  padding: 2%;
  img {
    max-width: 350px;
    max-height: 400px;
  }
}
.skult {
  opacity: 0.8;
  max-width: 100px;
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
}
</style>
